import React from "react";
import ButtonComplexComponent, {
  ButtonComplexProps,
} from "@/components/ButtonComplex";

// Cast to fix React 17 + @types/react 18 compatibility issue
const ButtonComplex = ButtonComplexComponent as any;

export type ButtonProps = ButtonComplexProps;

const Button: React.FC<ButtonComplexProps> = (props) => {
  return <ButtonComplex {...props} />;
};

export default Button;
